import {useEffect, useState} from "react";
import {isEmpty, isLoaded, useFirestoreConnect} from "react-redux-firebase";
import {useSelector} from "react-redux";

export default function useVendorList() {
    const [isLoading, setIsLoading] = useState(false);
    useFirestoreConnect(() => [
        {collection: 'vendors', storeAs: 'vendors'}
    ])
    const getUsers = useSelector(state => state.firestore.ordered.vendors);

    useEffect(() => {
        if (!isLoaded(getUsers)) {
            setIsLoading(true)
        } else setIsLoading(false)
    }, [getUsers])

    const vendors = isEmpty(getUsers) ? [] : getUsers;

    return {vendors, isLoading}
}
